// Lesson 3: Aktivitas Sore dan Malam Hari - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 3: Evening and Night Activities
export const unit5Lesson3VocabularyBank: Word[] = [
    {
        id: 301,
        batak: "ᯔᯀᯒᯖᯀᯰᯎᯤᯀᯰ",
        latin: ["mar", "ta", "ngi", "ang"],
        indonesia: "Pulang",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯒ", latin: "mar" },
            { batak_char: "ᯖᯀᯰ", latin: "ta" },
            { batak_char: "ᯎᯤ", latin: "ngi" },
            { batak_char: "ᯀᯰ", latin: "ang" }
        ]
    },
    {
        id: 302,
        batak: "ᯔᯀᯉᯬᯒᯖᯬᯒ",
        latin: ["ma", "nor", "tor"],
        indonesia: "Istirahat",
        syllable_mapping: [
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯉᯬᯒ", latin: "nor" },
            { batak_char: "ᯖᯬᯒ", latin: "tor" }
        ]
    },
    {
        id: 303,
        batak: "ᯔᯀᯉ᯲ᯑᯬᯂ᯲ ᯖᯜ",
        latin: ["man", "dok", "TV"],
        indonesia: "Menonton",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯉ᯲", latin: "man" },
            { batak_char: "ᯑᯬᯂ᯲", latin: "dok" },
            { batak_char: "ᯖᯜ", latin: "TV" }
        ]
    },
    {
        id: 304,
        batak: "ᯔᯀᯔᯀᯰᯀᯉ ᯎᯀᯄᯰ",
        latin: ["ma", "mang", "an", "ga", "beng"],
        indonesia: "Makan malam",
        syllable_mapping: [
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯔᯀᯰ", latin: "mang" },
            { batak_char: "ᯀᯉ", latin: "an" },
            { batak_char: "ᯎᯀ", latin: "ga" },
            { batak_char: "ᯄᯰ", latin: "beng" }
        ]
    },
    {
        id: 305,
        batak: "ᯔᯀᯔᯀᯖᯧ",
        latin: ["ma", "ma", "te"],
        indonesia: "Tidur",
        syllable_mapping: [
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯖᯧ", latin: "te" }
        ]
    },
    {
        id: 306,
        batak: "ᯂᯀᯔᯤ",
        latin: ["ha", "mi"],
        indonesia: "Kami",
        syllable_mapping: [
            { batak_char: "ᯂᯀ", latin: "ha" },
            { batak_char: "ᯔᯤ", latin: "mi" }
        ]
    },
    {
        id: 307,
        batak: "ᯑᯀᯒᯤ",
        latin: ["da", "ri"],
        indonesia: "dari",
        syllable_mapping: [
            { batak_char: "ᯑᯀ", latin: "da" },
            { batak_char: "ᯒᯤ", latin: "ri" }
        ]
    },
    {
        id: 308,
        batak: "ᯂᯮᯒᯤᯀ",
        latin: ["hu", "ri", "a"],
        indonesia: "Gereja",
        syllable_mapping: [
            { batak_char: "ᯂᯮ", latin: "hu" },
            { batak_char: "ᯒᯤ", latin: "ri" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 309,
        batak: "ᯎᯀᯄᯰ",
        latin: ["ga", "beng"],
        indonesia: "Malam",
        syllable_mapping: [
            { batak_char: "ᯎᯀ", latin: "ga" },
            { batak_char: "ᯄᯰ", latin: "beng" }
        ]
    },
    {
        id: 310,
        batak: "ᯀᯤᯘᯧ",
        latin: ["i", "se"],
        indonesia: "Mereka",
        syllable_mapping: [
            { batak_char: "ᯀᯤ", latin: "i" },
            { batak_char: "ᯘᯧ", latin: "se" }
        ]
    },
    {
        id: 306,
        batak: "ᯖᯀᯬᯉ᯲",
        latin: ["ta", "on"],
        indonesia: "Tahun",
        syllable_mapping: [
            { batak_char: "ᯖᯀ", latin: "ta" },
            { batak_char: "ᯬᯉ᯲", latin: "on" }
        ]
    },
    {
        id: 307,
        batak: "ᯖᯮᯀᯃᯮ",
        latin: ["tu", "a", "ku"],
        indonesia: "Umurku",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯃᯮ", latin: "ku" }
        ]
    },
    {
        id: 308,
        batak: "ᯇᯃᯮᯔᯀᯘ",
        latin: ["par", "ka", "mas"],
        indonesia: "Pekerja",
        syllable_mapping: [
            { batak_char: "ᯇᯃ", latin: "par" },
            { batak_char: "ᯃᯮ", latin: "ka" },
            { batak_char: "ᯔᯀᯘ", latin: "mas" }
        ]
    },
    // Numbers for age
    {
        id: 320,
        batak: "᯲᯲",
        latin: ["du", "a", "pu", "luh"],
        indonesia: "20",
        syllable_mapping: [
            { batak_char: "᯲", latin: "dua" },
            { batak_char: "᯲", latin: "puluh" }
        ]
    },
    {
        id: 325,
        batak: "᯲᯲᯲",
        latin: ["du", "a", "pu", "luh", "li", "ma"],
        indonesia: "25",
        syllable_mapping: [
            { batak_char: "᯲", latin: "dua" },
            { batak_char: "᯲", latin: "puluh" },
            { batak_char: "᯲", latin: "lima" }
        ]
    }
];

// Extended word bank for various question types
export const unit5Lesson3ExtendedWordBank: Word[] = [
    ...unit5Lesson3VocabularyBank,
    // Include some words from previous lessons for continuity
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 106,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 107,
        batak: "ᯀᯤ",
        latin: ["ia"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯀᯤ", latin: "ia" }
        ]
    },
    {
        id: 206,
        batak: "ᯉᯤ",
        latin: ["di"],
        indonesia: "di",
        syllable_mapping: [
            { batak_char: "ᯉᯤ", latin: "di" }
        ]
    },
    {
        id: 209,
        batak: "ᯅᯀᯎᯀᯘ",
        latin: ["ba", "gas"],
        indonesia: "Rumah",
        syllable_mapping: [
            { batak_char: "ᯅᯀ", latin: "ba" },
            { batak_char: "ᯎᯀᯘ", latin: "gas" }
        ]
    },
    {
        id: 200,
        batak: "?",
        latin: ["?"],
        indonesia: "?",
        syllable_mapping: [{ batak_char: "?", latin: "?" }],
    }
];

// Sample sentences for lesson 3: Evening and Night Activities
export const unit5Lesson3Sentences = [
    {
        id: 1,
        batak: "ᯂᯀᯔᯤ ᯔᯀᯒᯖᯀᯰᯎᯤᯀᯰ ᯑᯀᯒᯤ ᯂᯮᯒᯤᯀ.",
        latin: ["hami", "martangiang", "dari", "huria"],
        indonesia: "Kami pulang dari gereja.",
        word_ids: [306, 301, 307, 308]
    },
    {
        id: 2,
        batak: "ᯀᯤ ᯔᯀᯉ᯲ᯑᯬᯂ᯲ ᯖᯜ ᯉᯤ ᯅᯀᯎᯀᯘ.",
        latin: ["ia", "mandok", "TV", "di", "bagas"],
        indonesia: "Dia menonton TV di rumah.",
        word_ids: [107, 303, 206, 209]
    },
    {
        id: 3,
        batak: "ᯀᯤᯘᯧ ᯔᯀᯔᯀᯖᯧ ᯎᯀᯄᯰ.",
        latin: ["ise", "mamate", "gabeng"],
        indonesia: "Mereka tidur malam.",
        word_ids: [310, 305, 309]
    },
    {
        id: 4,
        batak: "ᯀᯮ ᯔᯀᯉᯬᯒᯖᯬᯒ ᯉᯤ ᯅᯀᯎᯀᯘ.",
        latin: ["au", "manortor", "di", "bagas"],
        indonesia: "Saya istirahat di rumah.",
        word_ids: [105, 302, 206, 209]
    },
    {
        id: 5,
        batak: "ᯂᯀᯔᯤ ᯔᯀᯔᯀᯰᯀᯉ ᯎᯀᯄᯰ ᯉᯤ ᯅᯀᯎᯀᯘ.",
        latin: ["hami", "mamangan", "gabeng", "di", "bagas"],
        indonesia: "Kami makan malam di rumah.",
        word_ids: [306, 304, 206, 209]
    }
];

// Helper function to create word dictionary
export const createUnit5Lesson3WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
